var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 2.5H18.3333C19.2538 2.5 20 3.24619 20 4.16667V15.6159C20 16.5364 19.2538 17.2826 18.3333 17.2826H1.66667C0.746192 17.2826 0 16.5364 0 15.6159V4.16667C0 3.24619 0.746192 2.5 1.66667 2.5Z",
    fill: "#243747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82616 13.3696C9.74715 13.3696 11.3044 11.8123 11.3044 9.89135C11.3044 7.97036 9.74715 6.41309 7.82616 6.41309C5.90517 6.41309 4.3479 7.97036 4.3479 9.89135C4.3479 11.8123 5.90517 13.3696 7.82616 13.3696Z",
    fill: "#E61C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1453 13.3696C14.0662 13.3696 15.6235 11.8123 15.6235 9.89135C15.6235 7.97036 14.0662 6.41309 12.1453 6.41309C10.2243 6.41309 8.66699 7.97036 8.66699 9.89135C8.66699 11.8123 10.2243 13.3696 12.1453 13.3696Z",
    fill: "#F99F1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98568 7.16797C9.1528 7.8264 8.66699 8.82974 8.66699 9.89145C8.66699 10.9532 9.1528 11.9565 9.98568 12.6149C10.8186 11.9565 11.3044 10.9532 11.3044 9.89145C11.3044 8.82974 10.8186 7.8264 9.98568 7.16797Z",
    fill: "#F26622"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.3d0f75426e8a62a26a4a074e83399e81.svg";
export { ForwardRef as ReactComponent };